import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Welcome to Smartix Studio!</Typography>
      <div>
        <p>Hopefully this is recognisable as a typical login page...</p>
        <p>If you already have an account then go ahead and login with your chosen signup method: Apple, Google, LinkedIn or with your email and password.</p>

        <Typography variant='h5' className='pt-10 pb-5'>Forgotten your password?</Typography>
        <p>If you have forgotten your password, or you signed up with App;e, Google or LinkedIn and wish to add
          a separate password to your account, then hit that [reset password] button!</p>

        <Typography variant='h5' className='pt-10 pb-5'>Don't have an account yet?</Typography>
        <p>Hit that [NEW TO SMARTIX] button and give us your name, email and choose a password, or sign up with your Apple, Google or LinkedIn accounts.</p>
        <p>We'll create you a <a href="https://www.smartix.uk/pricing/free-tier/" target='_blank'>FREE Tier</a> account, so you can try our Smartix and get started issuing passes completely free of charge.</p>

        <Typography variant='h5' className='pt-10 pb-5'>Not sure what Smartix Studio is?</Typography>
        <p>Take a look at our <a href="https://www.smartix.uk" target="_blank">website</a> for an introduction.</p>

        <Typography variant='h5' className='pt-10 pb-5'>Password strength</Typography>
        <p>We do not believe in forcing you to use uppercase, lowecase, numbers and special characters. Bill Burr, they guy who originally came up with those rules
          insistes he made a mistake and has spent years asking people to stop using them. He now recommends a long, memorable phrase. So go ahead, choose whatever 
          password you like that you can remember. The strength meter will tell you if it's enough or not. </p>
      </div>
    </div>
  )
}

export default HelpText